export default {
  data() {
    return {
      particles: [],
      mouse: { x: null, y: null },
      particleCount: 200,
      ctx: null,
      canvas: null,
      isLowPerformance: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.canvas = this.$refs.canvas;
      if (!this.canvas) {
        console.error("Canvas reference is null.");
        return;
      }
      this.ctx = this.canvas.getContext("2d");
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
      window.addEventListener("mousemove", this.updateMousePosition);
      window.addEventListener("resize", this.resizeCanvas);
      this.checkPerformance();
    });
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.updateMousePosition);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    checkPerformance() {
      if (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) {
        this.isLowPerformance = true;
        return;
      }

      let frames = 0;
      let startTime = performance.now();
      const checkFPS = () => {
        frames++;
        if (performance.now() - startTime > 1000) {
          const fps = frames;
          if (fps < 30) {
            this.isLowPerformance = true;
          }
        } else {
          requestAnimationFrame(checkFPS);
        }
      };
      requestAnimationFrame(checkFPS);

      setTimeout(() => {
        if (!this.isLowPerformance) {
          this.initParticles();
          this.animate();
          window.addEventListener("mousemove", this.updateMousePosition);
          window.addEventListener("resize", this.resizeCanvas);
        }
      }, 300);
    },

    updateMousePosition(event) {
      this.mouse.x = event.x;
      this.mouse.y = event.y;
    },

    resizeCanvas() {
      this.canvas.width = window.innerWidth;
      this.canvas.height = window.innerHeight;
    },

    initParticles() {
      class Particle {
        constructor(canvasWidth, canvasHeight) {
          this.x = Math.random() * canvasWidth;
          this.y = Math.random() * canvasHeight;
          this.vx = (Math.random() - 0.5) * 2;
          this.vy = (Math.random() - 0.5) * 2;
          this.size = 2;
          this.friction = 0.98;
          this.minSpeed = 0.2;
        }
        move(mouse, canvasWidth, canvasHeight) {
          this.x += this.vx;
          this.y += this.vy;

          if (this.x <= 0 || this.x >= canvasWidth) this.vx *= -1;
          if (this.y <= 0 || this.y >= canvasHeight) this.vy *= -1;

          const dx = this.x - mouse.x;
          const dy = this.y - mouse.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 100) {
            this.vx += (dx / distance) * 0.2;
            this.vy += (dy / distance) * 0.2;
          }

          this.vx *= this.friction;
          this.vy *= this.friction;

          if (Math.abs(this.vx) < this.minSpeed) this.vx = this.vx < 0 ? -this.minSpeed : this.minSpeed;
          if (Math.abs(this.vy) < this.minSpeed) this.vy = this.vy < 0 ? -this.minSpeed : this.minSpeed;
        }
        draw(ctx) {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
          ctx.fillStyle = "dimgray";
          ctx.fill();
        }
      }

      for (let i = 0; i < this.particleCount; i++) {
        this.particles.push(new Particle(this.canvas.width, this.canvas.height));
      }
    },

    connectParticles() {
      for (let i = 0; i < this.particles.length; i++) {
        for (let j = i + 1; j < this.particles.length; j++) {
          const dx = this.particles[i].x - this.particles[j].x;
          const dy = this.particles[i].y - this.particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 100) {
            this.ctx.beginPath();
            this.ctx.strokeStyle = `rgba(0, 0, 0, ${1 - distance / 100})`;
            this.ctx.lineWidth = 0.5;
            this.ctx.moveTo(this.particles[i].x, this.particles[i].y);
            this.ctx.lineTo(this.particles[j].x, this.particles[j].y);
            this.ctx.stroke();
          }
        }
      }
    },

    animate() {
      if (this.isLowPerformance) return;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.particles.forEach(particle => {
        particle.move(this.mouse, this.canvas.width, this.canvas.height);
        particle.draw(this.ctx);
      });
      this.connectParticles();
      requestAnimationFrame(this.animate);
    }
  }
};
